import {
	businessConstants, preAppConstants
} from 'store';

var initialState = {
	loading: false,
	error: null,
}

export function business(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case businessConstants.SEND_BUSINESS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case businessConstants.SEND_BUSINESS_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case businessConstants.SEND_BUSINESS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state
	}
}